import { render, staticRenderFns } from "./moduleConfig.vue?vue&type=template&id=6fa6b990&scoped=true"
import script from "./moduleConfig.vue?vue&type=script&lang=js"
export * from "./moduleConfig.vue?vue&type=script&lang=js"
import style0 from "./moduleConfig.vue?vue&type=style&index=0&id=6fa6b990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa6b990",
  null
  
)

export default component.exports